//Library Imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local Imports
import { EMAIL_LIST } from "constants/types";
import { TAB_TYPES } from "constants/types/tabTypes";
import SmartSourceContent from "modules/Campaigns/Shared/SmartSourceContent";

//Style Imports
import styled from "styled-components";

interface ICampaignSmartSourcedContent {
  isCampaign?: boolean;
}

const CampaignSmartSourcedContent: React.FC<ICampaignSmartSourcedContent> = (props) => {
  const campaignName: string = useSelector((state: RootState) => state.emails.campaignName);
  const campaignKeywords: string[] = useSelector((state: RootState) => state.emails.campaignKeywords);
  const noKeywords: boolean = useSelector((state: RootState) => state.emails.noKeywords);

  const [campaignKeywordsState, setCampaignKeywordsState] = useState<string[]>([]);

  useEffect(() => {
    const lowerCasedCampaignKeywords = campaignKeywords.map((keyword) => keyword.toLowerCase());
    const uniqueCampaignKeywords = [...new Set(lowerCasedCampaignKeywords)];
    setCampaignKeywordsState(uniqueCampaignKeywords);
  }, [campaignKeywords]);

  useEffect(() => {
    return () => {
      store.dispatch({
        type: EMAIL_LIST.UPDATE_CAMPAIGN_KEYWORDS,
        payload: [],
      });
    };
  }, []);

  return (
    <Wrapper>
      <SmartSourceContent
        tab={"asset"}
        searchTerms={campaignKeywordsState}
        savedKeywords={campaignKeywordsState}
        noKeywords={noKeywords}
        title={campaignName}
        tabType={TAB_TYPES.ASSET}
        hideHeader={true}
        hideFocusMessage={true}
        isAssetWithoutCampaign={false}
        hideCMS={true}
        description={
          "Add keywords to start finding SmartSourced content for this campaign. We'll present you with timely content that meets your criteria."
        }
        isCampaign={props.isCampaign}
      />
    </Wrapper>
  );
};

export default CampaignSmartSourcedContent;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 6px;
  .message-wrapper {
    margin-bottom: 138px;
  }
  .message-container {
    flex: 1;
    padding: 2% 19%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    h2 {
      color: #424b50;
      font-family: "Roboto Slab", serif;
      font-weight: 600;
      margin-bottom: 5%;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 20px;
      }
    }
  }
`;
